export default __webpack_public_path__ + "static/media/volunteer3.2d0162d8.jpg";